<template>
  <div>
    <v-dialog
      class="paper-dialog"
      title="Edit Content"
      :visible.sync="dialogVisible"
      width="50vw"
      @open="onOpen"
      @close="onClosed"
    >
      <el-form
        class="padding-lr"
        ref="form"
        :model="form"
        :rules="formRules"
        label-width="210px"
        v-loading="loading"
        element-loading-text="loading..."
      >
        <el-form-item label="Content Category" prop="categoryId">
          <div class="cate-select-add">
            <el-select
              placeholder="Please select content category"
              v-model="form.categoryId"
            >
              <el-option
                v-for="(item, index) in categoryList"
                :label="item.CategoryName"
                :value="item.PaperCategoryID"
                :key="index"
              >
                <div class="select-option-item" :title="item.CategoryName">
                  {{ item.CategoryName }}
                </div>
              </el-option>
            </el-select>
            <el-button icon="el-icon-plus" @click="showCateDialog" />
          </div>
        </el-form-item>
        <el-form-item label="Short Title" prop="shortTitle">
          <el-input
            placeholder="Please input short title"
            v-model="form.shortTitle"
            maxlength="100"
          />
        </el-form-item>
        <el-form-item label="Search Term" prop="searchTerm">
          <el-input
            placeholder="Please input search term"
            v-model="form.searchTerm"
            maxlength="100"
          />
        </el-form-item>
        <el-form-item
          label="Allow Full Article Request"
          prop="fullPaperRequest"
        >
          <el-radio-group v-model="form.fullPaperRequest">
            <el-radio :label="1">Yes</el-radio>
            <el-radio :label="0">No</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="data">
          <el-form-item label="Any Comments">
            <div class="any-comments-wrapper">{{ data.AnyComments }}</div>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer" class="push-footer">
        <el-button type="primary" @click="onSubmit"> Submit </el-button>
        <el-button plain @click="onClosed"> Cancel </el-button>
      </div>
    </v-dialog>
    <NewCategoryDialog
      :visible.sync="addCategoryDialogVisible"
      @success="onNewCateSuccess"
      @closed="onNewCateClosed"
    />
  </div>
</template>
<script>
import NewCategoryDialog from "./new-category-dialog.vue";
import { trimValidate } from "../../utils/validator";
export default {
  name: "new-paper-dialog",
  components: { NewCategoryDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      categoryList: [],
      form: {
        seId: null,
        categoryId: "",
        shortTitle: "",
        searchTerm: "",
        fullPaperRequest: 1,
      },
      formRules: {
        categoryId: [
          {
            required: true,
            message: "Please select content category",
            trigger: "change",
          },
        ],
        shortTitle: [
          {
            required: true,
            validator: trimValidate("Please input short title"),
            trigger: "blur",
          },
        ],
        searchTerm: [
          {
            required: true,
            validator: trimValidate("Please input search term"),
            trigger: "blur",
          },
        ],
        fullPaperRequest: [
          {
            required: true,
            message: "Please check the full paper request radio button",
            trigger: "blur",
          },
        ],
      },
      hidePaperDialog: false,
      addCategoryDialogVisible: false,
      loading: false,
    };
  },
  computed: {
    action() {
      return `${process.env.VUE_APP_SERVER_API}/content/uploadFile`;
    },
    headers() {
      return { Authorization: this.$store.state.token };
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  methods: {
    onClosed() {
      if (!this.hidePaperDialog) {
        this.$refs.form.resetFields();
        this.$emit("update:data", null);
        this.$emit("update:visible", false);
      }
    },
    onOpen() {
      this.getCategoryList();
      if (this.data && !this.hidePaperDialog) {
        const { PaperCategoryID, ShortTitle, SearchTerm, FullPaperRequest } =
          this.data;
        this.form.categoryId = PaperCategoryID;
        this.form.shortTitle = ShortTitle;
        this.form.searchTerm = SearchTerm;
        if (FullPaperRequest !== null) {
          this.form.fullPaperRequest = FullPaperRequest;
        }
      }
      if (this.hidePaperDialog) {
        this.hidePaperDialog = false;
      }
    },
    getCategoryList() {
      this.loading = true;
      this.axios.get("/content/categoryList").then(({ code, data, msg }) => {
        if (code === 200) {
          this.categoryList = data;
          this.loading = false;
        } else {
          this.$message.error(msg);
        }
      });
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.axios
            .post("/content/updateContent", {
              ...this.form,
              shortTitle: this.form.shortTitle.trim(),
              searchTerm: this.form.searchTerm.trim(),
              paperId: this.data.PaperID,
            })
            .then(({ code, msg }) => {
              if (code == 200) {
                this.$message.success("Update content successfully");
                this.$emit("success");
                this.$emit("update:visible", false);
              } else {
                this.$message.error(msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    showCateDialog() {
      this.hidePaperDialog = true;
      this.dialogVisible = false;
      this.addCategoryDialogVisible = true;
    },
    onNewCateSuccess(categoryId) {
      this.getCategoryList();
      this.form.categoryId = categoryId;
    },
    onNewCateClosed() {
      this.dialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.paper-dialog {
  ::v-deep .el-dialog__body {
    padding: 15px 0;
    display: flex;
    max-height: 70vh;
  }
}
::v-deep {
  .el-scrollbar.dialog {
    width: 100%;
  }
  .el-scrollbar__wrap {
    margin-bottom: 0 !important;
  }
  .el-form-item__label {
    color: #555;
    font-weight: bold;
  }
  .select-option-item {
    max-width: 25vw;
  }
}
.el-select + .el-button {
  margin-left: 10px;
}
.push-footer {
  text-align: center;
}
.el-form-item {
  margin-bottom: 15px !important;
  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }
  &.replace-file {
    ::v-deep {
      .el-form-item__content {
        display: flex;
      }
    }
  }
  .cate-select-add {
    width: 90%;
    display: flex;
    .el-select {
      flex: 1;
    }
  }
  &.editor {
    margin-bottom: 0 !important;
  }
  .any-comments-wrapper {
    padding-right: 50px;
    word-break: break-word;
    max-height: 200px;
    overflow: scroll;
  }
}
</style>
